import "./index.css";
import GdnAdTemplate from "../GdnAdTemplate";

/**
 * Google Display Network — 300×250 medium rectangle (rendered @2× = 600×500).
 * Horizontal logo lockup + editable "| <ProductName>". Shared body +
 * v3 background/logo handling live in ../GdnAdTemplate + libs/gdn-*.
 */
const InlineRectangleAds = ({id, zoom}) => (
  <GdnAdTemplate id={id} zoom={zoom} variant="horizontal" />
);

export default InlineRectangleAds;
